export default "__VITE_ASSET__RDLTS4G7__"